import { useEffect, useState } from "react";
import { API_BASE_URL } from "../../../config/api";

/**
 * Server-held two-innings scorecard (POST /casino/casino/superover-scorecard — the same public,
 * read-only endpoint the user site uses; the feed's t1.card only carries the current over).
 * Returns { phase, battingTeam, firstTeam, scoreByTeam, team1, team2, gmid, overBalls?, inningsBalls?, maxWickets? } | null.
 * NOTE: belongs in apiservices/CasionApi.jsx (frozen for this pass) — reported as a shared change.
 */
export default function useFiveCricketScorecard(type, enabled) {
  const [scorecard, setScorecard] = useState(null);

  useEffect(() => {
    if (!type || !enabled) return undefined;
    let alive = true;
    const load = () =>
      fetch(`${API_BASE_URL}/casino/casino/superover-scorecard`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ type }),
      })
        .then((r) => r.json())
        .then((res) => {
          if (alive) setScorecard(res?.data || null);
        })
        .catch(() => {});
    load();
    const poll = setInterval(load, 1500);
    return () => {
      alive = false;
      clearInterval(poll);
    };
  }, [type, enabled]);

  return scorecard;
}
